package mobile.icard.ICardRoomDatabase

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.ByteArray
import kotlin.Double
import kotlin.Long
import kotlin.String

public class EmbeddingsQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> getEmbeddingByMerchantLocationIdAndDocType(
    merchantLocationId: Long,
    docType: String,
    mapper: (
      merchantLocationId: Long,
      cityId: Long,
      lang: String,
      docType: String,
      qScale: Double,
      qZeroPoint: Long,
      vecQint8: ByteArray,
      lastModifiedIso: String,
    ) -> T,
  ): Query<T> = GetEmbeddingByMerchantLocationIdAndDocTypeQuery(merchantLocationId, docType) {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getDouble(4)!!,
      cursor.getLong(5)!!,
      cursor.getBytes(6)!!,
      cursor.getString(7)!!
    )
  }

  public fun getEmbeddingByMerchantLocationIdAndDocType(merchantLocationId: Long, docType: String):
      Query<Embeddings> = getEmbeddingByMerchantLocationIdAndDocType(merchantLocationId, docType) {
      merchantLocationId_, cityId, lang, docType_, qScale, qZeroPoint, vecQint8, lastModifiedIso ->
    Embeddings(
      merchantLocationId_,
      cityId,
      lang,
      docType_,
      qScale,
      qZeroPoint,
      vecQint8,
      lastModifiedIso
    )
  }

  public fun <T : Any> getEmbeddingsByCityId(cityId: Long, mapper: (
    merchantLocationId: Long,
    cityId: Long,
    lang: String,
    docType: String,
    qScale: Double,
    qZeroPoint: Long,
    vecQint8: ByteArray,
    lastModifiedIso: String,
  ) -> T): Query<T> = GetEmbeddingsByCityIdQuery(cityId) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getDouble(4)!!,
      cursor.getLong(5)!!,
      cursor.getBytes(6)!!,
      cursor.getString(7)!!
    )
  }

  public fun getEmbeddingsByCityId(cityId: Long): Query<Embeddings> =
      getEmbeddingsByCityId(cityId) { merchantLocationId, cityId_, lang, docType, qScale,
      qZeroPoint, vecQint8, lastModifiedIso ->
    Embeddings(
      merchantLocationId,
      cityId_,
      lang,
      docType,
      qScale,
      qZeroPoint,
      vecQint8,
      lastModifiedIso
    )
  }

  public fun <T : Any> getEmbeddingsByCityIdAndLang(
    cityId: Long,
    lang: String,
    mapper: (
      merchantLocationId: Long,
      cityId: Long,
      lang: String,
      docType: String,
      qScale: Double,
      qZeroPoint: Long,
      vecQint8: ByteArray,
      lastModifiedIso: String,
    ) -> T,
  ): Query<T> = GetEmbeddingsByCityIdAndLangQuery(cityId, lang) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getDouble(4)!!,
      cursor.getLong(5)!!,
      cursor.getBytes(6)!!,
      cursor.getString(7)!!
    )
  }

  public fun getEmbeddingsByCityIdAndLang(cityId: Long, lang: String): Query<Embeddings> =
      getEmbeddingsByCityIdAndLang(cityId, lang) { merchantLocationId, cityId_, lang_, docType,
      qScale, qZeroPoint, vecQint8, lastModifiedIso ->
    Embeddings(
      merchantLocationId,
      cityId_,
      lang_,
      docType,
      qScale,
      qZeroPoint,
      vecQint8,
      lastModifiedIso
    )
  }

  public fun <T : Any> getEmbeddingsByCityIdAndDocType(
    cityId: Long,
    docType: String,
    mapper: (
      merchantLocationId: Long,
      cityId: Long,
      lang: String,
      docType: String,
      qScale: Double,
      qZeroPoint: Long,
      vecQint8: ByteArray,
      lastModifiedIso: String,
    ) -> T,
  ): Query<T> = GetEmbeddingsByCityIdAndDocTypeQuery(cityId, docType) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getDouble(4)!!,
      cursor.getLong(5)!!,
      cursor.getBytes(6)!!,
      cursor.getString(7)!!
    )
  }

  public fun getEmbeddingsByCityIdAndDocType(cityId: Long, docType: String): Query<Embeddings> =
      getEmbeddingsByCityIdAndDocType(cityId, docType) { merchantLocationId, cityId_, lang,
      docType_, qScale, qZeroPoint, vecQint8, lastModifiedIso ->
    Embeddings(
      merchantLocationId,
      cityId_,
      lang,
      docType_,
      qScale,
      qZeroPoint,
      vecQint8,
      lastModifiedIso
    )
  }

  public fun <T : Any> getAllEmbeddings(mapper: (
    merchantLocationId: Long,
    cityId: Long,
    lang: String,
    docType: String,
    qScale: Double,
    qZeroPoint: Long,
    vecQint8: ByteArray,
    lastModifiedIso: String,
  ) -> T): Query<T> = Query(2_079_007_357, arrayOf("embeddings"), driver, "Embeddings.sq",
      "getAllEmbeddings",
      "SELECT embeddings.merchantLocationId, embeddings.cityId, embeddings.lang, embeddings.docType, embeddings.qScale, embeddings.qZeroPoint, embeddings.vecQint8, embeddings.lastModifiedIso FROM embeddings") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getDouble(4)!!,
      cursor.getLong(5)!!,
      cursor.getBytes(6)!!,
      cursor.getString(7)!!
    )
  }

  public fun getAllEmbeddings(): Query<Embeddings> = getAllEmbeddings { merchantLocationId, cityId,
      lang, docType, qScale, qZeroPoint, vecQint8, lastModifiedIso ->
    Embeddings(
      merchantLocationId,
      cityId,
      lang,
      docType,
      qScale,
      qZeroPoint,
      vecQint8,
      lastModifiedIso
    )
  }

  public fun countEmbeddings(): Query<Long> = Query(-1_988_707_851, arrayOf("embeddings"), driver,
      "Embeddings.sq", "countEmbeddings", "SELECT COUNT(*) FROM embeddings") { cursor ->
    cursor.getLong(0)!!
  }

  public fun upsertEmbedding(
    merchantLocationId: Long,
    cityId: Long,
    lang: String,
    docType: String,
    qScale: Double,
    qZeroPoint: Long,
    vecQint8: ByteArray,
    lastModifiedIso: String,
  ) {
    driver.execute(-114_630_030, """
        |INSERT OR REPLACE INTO embeddings(
        |  merchantLocationId, cityId, lang, docType, qScale, qZeroPoint, vecQint8, lastModifiedIso
        |) VALUES (?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 8) {
          bindLong(0, merchantLocationId)
          bindLong(1, cityId)
          bindString(2, lang)
          bindString(3, docType)
          bindDouble(4, qScale)
          bindLong(5, qZeroPoint)
          bindBytes(6, vecQint8)
          bindString(7, lastModifiedIso)
        }
    notifyQueries(-114_630_030) { emit ->
      emit("embeddings")
    }
  }

  public fun deleteEmbeddingByMerchantLocationIdAndDocType(merchantLocationId: Long,
      docType: String) {
    driver.execute(657_807_232,
        """DELETE FROM embeddings WHERE merchantLocationId = ? AND docType = ?""", 2) {
          bindLong(0, merchantLocationId)
          bindString(1, docType)
        }
    notifyQueries(657_807_232) { emit ->
      emit("embeddings")
    }
  }

  public fun deleteEmbeddingsByMerchantLocationId(merchantLocationId: Long) {
    driver.execute(-1_193_738_836, """DELETE FROM embeddings WHERE merchantLocationId = ?""", 1) {
          bindLong(0, merchantLocationId)
        }
    notifyQueries(-1_193_738_836) { emit ->
      emit("embeddings")
    }
  }

  public fun deleteEmbeddingsByCityId(cityId: Long) {
    driver.execute(1_492_898_810, """DELETE FROM embeddings WHERE cityId = ?""", 1) {
          bindLong(0, cityId)
        }
    notifyQueries(1_492_898_810) { emit ->
      emit("embeddings")
    }
  }

  private inner class GetEmbeddingByMerchantLocationIdAndDocTypeQuery<out T : Any>(
    public val merchantLocationId: Long,
    public val docType: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("embeddings", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("embeddings", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(231_971_745,
        """SELECT embeddings.merchantLocationId, embeddings.cityId, embeddings.lang, embeddings.docType, embeddings.qScale, embeddings.qZeroPoint, embeddings.vecQint8, embeddings.lastModifiedIso FROM embeddings WHERE merchantLocationId = ? AND docType = ?""",
        mapper, 2) {
      bindLong(0, merchantLocationId)
      bindString(1, docType)
    }

    override fun toString(): String = "Embeddings.sq:getEmbeddingByMerchantLocationIdAndDocType"
  }

  private inner class GetEmbeddingsByCityIdQuery<out T : Any>(
    public val cityId: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("embeddings", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("embeddings", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-54_649_543,
        """SELECT embeddings.merchantLocationId, embeddings.cityId, embeddings.lang, embeddings.docType, embeddings.qScale, embeddings.qZeroPoint, embeddings.vecQint8, embeddings.lastModifiedIso FROM embeddings WHERE cityId = ?""",
        mapper, 1) {
      bindLong(0, cityId)
    }

    override fun toString(): String = "Embeddings.sq:getEmbeddingsByCityId"
  }

  private inner class GetEmbeddingsByCityIdAndLangQuery<out T : Any>(
    public val cityId: Long,
    public val lang: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("embeddings", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("embeddings", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_534_487_316,
        """SELECT embeddings.merchantLocationId, embeddings.cityId, embeddings.lang, embeddings.docType, embeddings.qScale, embeddings.qZeroPoint, embeddings.vecQint8, embeddings.lastModifiedIso FROM embeddings WHERE cityId = ? AND lang = ?""",
        mapper, 2) {
      bindLong(0, cityId)
      bindString(1, lang)
    }

    override fun toString(): String = "Embeddings.sq:getEmbeddingsByCityIdAndLang"
  }

  private inner class GetEmbeddingsByCityIdAndDocTypeQuery<out T : Any>(
    public val cityId: Long,
    public val docType: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("embeddings", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("embeddings", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-694_591_276,
        """SELECT embeddings.merchantLocationId, embeddings.cityId, embeddings.lang, embeddings.docType, embeddings.qScale, embeddings.qZeroPoint, embeddings.vecQint8, embeddings.lastModifiedIso FROM embeddings WHERE cityId = ? AND docType = ?""",
        mapper, 2) {
      bindLong(0, cityId)
      bindString(1, docType)
    }

    override fun toString(): String = "Embeddings.sq:getEmbeddingsByCityIdAndDocType"
  }
}
